export default "__VITE_ASSET__uViS_wj1__"